/* ===== GAMESTRIX CUSTOM: country-info.js =====
   Zeigt die Regionsverfuegbarkeit als lila Badge ("Activates in <Land>").
   Nutzt eine feste Laendernamen-Tabelle (keine externe API mehr = schneller & ausfallsicher).
   Aendern der Texte: siehe renderCountryInfo() weiter unten.
=============================================== */
(function () {
  // -------------- LAENDERNAMEN (ISO alpha-2 -> Anzeigename) --------------
  const COUNTRY_NAMES = {
    ad: 'Andorra',
    ae: 'United Arab Emirates',
    af: 'Afghanistan',
    ag: 'Antigua and Barbuda',
    ai: 'Anguilla',
    al: 'Albania',
    ao: 'Angola',
    at: 'Austria',
    au: 'Australia',
    aw: 'Aruba',
    ax: 'Åland Islands',
    ba: 'Bosnia and Herzegovina',
    bb: 'Barbados',
    be: 'Belgium',
    bf: 'Burkina Faso',
    bg: 'Bulgaria',
    bi: 'Burundi',
    bj: 'Benin',
    bl: 'Saint Barthélemy',
    bm: 'Bermuda',
    bn: 'Brunei Darussalam',
    bq: 'Caribbean Netherlands',
    br: 'Brazil',
    bs: 'Bahamas',
    bw: 'Botswana',
    ca: 'Canada',
    cc: 'Cocos (Keeling) Islands',
    cd: 'DR Congo',
    cf: 'Central African Republic',
    cg: 'Congo',
    ch: 'Switzerland',
    ci: 'Côte d\'Ivoire',
    ck: 'Cook Islands',
    cl: 'Chile',
    cm: 'Cameroon',
    cn: 'China',
    co: 'Colombia',
    cr: 'Costa Rica',
    cv: 'Cabo Verde',
    cw: 'Curaçao',
    cx: 'Christmas Island',
    cy: 'Cyprus',
    cz: 'Czechia',
    de: 'Germany',
    dj: 'Djibouti',
    dk: 'Denmark',
    dm: 'Dominica',
    do: 'Dominican Republic',
    ee: 'Estonia',
    eh: 'Western Sahara',
    er: 'Eritrea',
    es: 'Spain',
    et: 'Ethiopia',
    fi: 'Finland',
    fj: 'Fiji',
    fk: 'Falkland Islands (Malvinas)',
    fo: 'Faroe Islands',
    fr: 'France',
    ga: 'Gabon',
    gb: 'United Kingdom',
    gd: 'Grenada',
    gf: 'French Guiana',
    gg: 'Guernsey',
    gh: 'Ghana',
    gi: 'Gibraltar',
    gl: 'Greenland',
    gm: 'Gambia',
    gn: 'Guinea',
    gp: 'Guadeloupe',
    gq: 'Equatorial Guinea',
    gr: 'Greece',
    gs: 'South Georgia',
    gw: 'Guinea-Bissau',
    hk: 'Hong Kong',
    hr: 'Croatia',
    ht: 'Haiti',
    hu: 'Hungary',
    id: 'Indonesia',
    ie: 'Ireland',
    il: 'Israel',
    im: 'Isle of Man',
    in: 'India',
    io: 'British Indian Ocean Territory',
    is: 'Iceland',
    it: 'Italy',
    je: 'Jersey',
    jm: 'Jamaica',
    jp: 'Japan',
    ke: 'Kenya',
    kh: 'Cambodia',
    ki: 'Kiribati',
    km: 'Comoros',
    kn: 'Saint Kitts and Nevis',
    kr: 'South Korea',
    ky: 'Cayman Islands',
    kz: 'Kazakhstan',
    la: 'Laos',
    lc: 'Saint Lucia',
    li: 'Liechtenstein',
    lr: 'Liberia',
    ls: 'Lesotho',
    lt: 'Lithuania',
    lu: 'Luxembourg',
    lv: 'Latvia',
    mc: 'Monaco',
    me: 'Montenegro',
    mf: 'Saint Martin (French part)',
    mg: 'Madagascar',
    mk: 'North Macedonia',
    ml: 'Mali',
    mm: 'Myanmar',
    mn: 'Mongolia',
    mo: 'Macao',
    mq: 'Martinique',
    mr: 'Mauritania',
    ms: 'Montserrat',
    mt: 'Malta',
    mu: 'Mauritius',
    mv: 'Maldives',
    mw: 'Malawi',
    mx: 'Mexico',
    my: 'Malaysia',
    mz: 'Mozambique',
    na: 'Namibia',
    nc: 'New Caledonia',
    ne: 'Niger',
    nf: 'Norfolk Island',
    ng: 'Nigeria',
    nl: 'Netherlands',
    no: 'Norway',
    nr: 'Nauru',
    nu: 'Niue',
    nz: 'New Zealand',
    pe: 'Peru',
    pf: 'French Polynesia',
    pg: 'Papua New Guinea',
    ph: 'Philippines',
    pl: 'Poland',
    pm: 'Saint Pierre and Miquelon',
    pn: 'Pitcairn',
    pt: 'Portugal',
    qa: 'Qatar',
    re: 'Réunion',
    ro: 'Romania',
    rs: 'Serbia',
    ru: 'Russia',
    rw: 'Rwanda',
    sa: 'Saudi Arabia',
    sb: 'Solomon Islands',
    sc: 'Seychelles',
    se: 'Sweden',
    sg: 'Singapore',
    sh: 'Saint Helena, Ascension and Tristan da Cunha',
    si: 'Slovenia',
    sj: 'Svalbard and Jan Mayen',
    sk: 'Slovakia',
    sl: 'Sierra Leone',
    sm: 'San Marino',
    sn: 'Senegal',
    so: 'Somalia',
    ss: 'South Sudan',
    st: 'Sao Tome and Principe',
    sx: 'Sint Maarten',
    sz: 'Eswatini',
    td: 'Chad',
    tf: 'French Southern Territories',
    tg: 'Togo',
    th: 'Thailand',
    tk: 'Tokelau',
    tt: 'Trinidad and Tobago',
    tv: 'Tuvalu',
    tw: 'Taiwan',
    tz: 'Tanzania',
    ua: 'Ukraine',
    ug: 'Uganda',
    um: 'U.S. Outlying Islands',
    us: 'United States',
    uy: 'Uruguay',
    va: 'Vatican City',
    vn: 'Vietnam',
    yt: 'Mayotte',
    za: 'South Africa',
    zm: 'Zambia',
    zw: 'Zimbabwe'
  };

const HANDLE_NORMALIZATION = { en: 'gb', eu: 'de' };

  function countryName(code2) {
    return COUNTRY_NAMES[code2] || code2.toUpperCase();
  }

function renderBadge(root, code2) {
    const name = countryName(code2);
    root.innerHTML = `
      <div class="gsx-region-big">
        <span class="gsx-region-big__check" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
        </span>
        <span class="gsx-region-big__text">Activates in ${name}</span>
      </div>
    `;
  }

  function init() {
    ['market-country-info', 'market-country-info-2', 'market-country-info-3'].forEach(function (id) {
      const root = document.getElementById(id);
      if (!root) return;
      const raw = (root.getAttribute('data-market-code') || '').toLowerCase();
      if (!raw) return;
      const norm = HANDLE_NORMALIZATION[raw] || raw;
      const iso2 = /^[a-z]{2}$/i.test(norm) ? norm : raw;
      renderBadge(root, iso2);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
